import { listOfPangkat } from 'types/kinerja'

import type { Jenjang, Pangkat } from 'types/kinerja'

export { listOfPangkat }

const mapJenjangToPangkat: Record<Jenjang, string[]> = {
  'ahli pertama': ['III/A', 'III/B'],
  'ahli muda': ['III/C', 'III/D'],
  'ahli madya': ['IV/A', 'IV/B', 'IV/C'],
  'ahli utama': ['IV/D', 'IV/E'],
  'bawah pertama': ['LTIII/A'],

  pertama: ['III/A', 'III/B'],
  muda: ['III/C', 'III/D'],
  madya: ['IV/A', 'IV/B', 'IV/C'],
  utama: ['IV/D', 'IV/E'],
}

export function isValidPangkat(pangkat: string): pangkat is Pangkat {
  return listOfPangkat
    .map((pangkat) => pangkat.toUpperCase())
    .includes(pangkat.toUpperCase())
}

export function checkPangkatAndJenjang(
  pangkat: string,
  jenjang: Jenjang
): boolean {
  return mapJenjangToPangkat[jenjang]?.includes(pangkat.toUpperCase()) ?? false
}

export const pangkatGolonganMapping: Record<Pangkat, string> = {
  'LTIII/A': 'Di bawah Penata Muda, III/a',
  'III/A': 'Penata Muda, III/a',
  'III/B': 'Penata Muda Tingkat I, III/b',
  'III/C': 'Penata, III/c',
  'III/D': 'Penata Tingkat I, III/d',
  'IV/A': 'Pembina, IV/a',
  'IV/B': 'Pembina Tingkat I, IV/b',
  'IV/C': 'Pembina Utama Muda, IV/c',
  'IV/D': 'Pembina Utama Madya, IV/d',
  'IV/E': 'Pembina Utama, IV/e',
}

export function getPangkatGolongan(pangkat: string): string {
  if (!isValidPangkat(pangkat)) {
    return '-'
  }

  return pangkatGolonganMapping[pangkat]
}
